<template>
  <a
    class="k-chk"
    :class="{checked: checked === true}"
    href="javascript:;"
    :title="title || ''"
    @click="click"
    :r-eid="`k-chk-${name}`"
  >
    <slot></slot>
  </a>
</template>

<script>
  export default {
    name: 'k-chk',
    props: ['checked', 'name', 'title'],
    computed: {
      isChecked() {
        return this.checked === true;
      }
    },
    watch: {
      isChecked(checked) {
        const {name} = this;
        this.$emit('changed', {
          name,
          checked
        });
      }
    },
    methods: {
      click() {
        const {isChecked, name} = this;
        this.$emit('click', {
          name,
          checked: isChecked
        });
      }
    }
  };
</script>
